import { UniversalConfig } from '@application/universal_config.service';
import { tokens } from '@cellula/react-theme-patient';
import { useResolve } from '@visiba/instantiation';
import { AnimatePresence, motion } from 'framer-motion';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Consent } from './consent.component';
import { ConsentService } from './consent.service';

export function ConsentProvider(props: PropsWithChildren) {
	const controller = useResolve(ConsentService);
	const universalConfig = useResolve(UniversalConfig);

	return (
		<>
			{props.children}

			<StyledConsentProvider>
				<AnimatePresence initial={false}>
					{controller.hasRevision.value || universalConfig.disableTrackingCookies ? null : (
						<StyledConsentAnimation
							transition={{
								opacity: {
									duration: 0.1,
								},
								type: 'spring',
								damping: 25,
								stiffness: 100,
							}}
							animate={{
								opacity: 1,
								y: 0,
							}}
							exit={{
								opacity: 0,
							}}
						>
							<Consent />
						</StyledConsentAnimation>
					)}
				</AnimatePresence>
			</StyledConsentProvider>
		</>
	);
}

const StyledConsentProvider = styled.div`
	position: fixed;
	bottom: ${tokens.spacing.x2};
	left: ${tokens.spacing.x2};
	right: ${tokens.spacing.x2};
	pointer-events: none;
	z-index: 1;

	${tokens.breakpointQuery.small} {
		left: ${tokens.spacing.x2};
		max-width: 480px;
	}
`;

const StyledConsentAnimation = styled(motion.div)``;
